'use client';

import { useProfileInfoQuery } from '@/entities/profile';
import { PersonalDataProfile as PersonalDataProfileFeature } from '@/features/NewLanding';
import { useUIOverlay } from '@/shared/hooks';

interface PersonalDataProfileProps {
  yozmitProfileId: number;
  imgSrc?: string;
  name: string;
  roleKor: string;
}

export const PersonalDataProfile = ({
  yozmitProfileId,
  imgSrc,
  name,
  roleKor,
}: PersonalDataProfileProps) => {
  const { handleOpen } = useUIOverlay();
  const { data: profileInfo } = useProfileInfoQuery({
    yozmitProfileId: yozmitProfileId,
    useSuspense: true,
  });

  return (
    <PersonalDataProfileFeature
      imgSrc={imgSrc}
      name={name}
      rank={profileInfo.activityScorePercentages}
      career={profileInfo.career}
      role={roleKor}
      openProfileEdit={() => handleOpen('profile')}
    />
  );
};
